import { createContext, useReducer } from "react";

export const MessageContext = createContext();

export const messageReducer = (state, action) => {
    switch (action.type) {
        case 'SET_MESSAGE':
            return {
                message1: action.payload
            }
        case 'CREATE_MESSAGE':
            return {
                message1: [action.payload, ...state.message1]
            }
        case 'DELETE_MESSAGE':
            return {
                message1: state.message1.filter(a => a._id !== action.payload._id)
            }
        default:
            return state
    };
};

export const MessageContextProvider = ({ children }) => {
    const [state, dispatch] = useReducer(messageReducer, {
        message1: null
    });

    return (
        <MessageContext.Provider value={{ ...state, dispatch }}>
            {children}
        </MessageContext.Provider>
    );
};